import { c as _c } from "react/compiler-runtime";
import { formatContractLabel } from "../formatters";
import type { GrantItemErrorProps } from "../types";
import { GrantExpiryBadge } from "./GrantExpiryBadge";
import { StatusBadge } from "./StatusBadge";
import { GrantDetailsGrid } from "./GrantDetailsGrid";
import { GrantErrorDetails } from "./GrantErrorDetails";
export function GrantItemError(t0) {
  const $ = _c(25);
  const {
    contractLabel,
    details,
    errorDetails,
    status,
    validFrom,
    validTo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-m-0 tw-text-sm tw-font-semibold tw-text-iron-100">Contract details unavailable</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== contractLabel) {
    t2 = formatContractLabel(contractLabel);
    $[1] = contractLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `We couldn't load metadata for ${t2}.`;
  let t4;
  if ($[3] !== t3) {
    t4 = <div>{t1}<p className="tw-m-0 tw-text-xs tw-text-iron-400">{t3}</p></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== validTo) {
    t5 = <GrantExpiryBadge validUntil={validTo} />;
    $[5] = validTo;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== status || $[8] !== validFrom || $[9] !== validTo) {
    t6 = <StatusBadge status={status} validFrom={validFrom} validTo={validTo} />;
    $[7] = status;
    $[8] = validFrom;
    $[9] = validTo;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-3">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <header className="tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-4">{t4}{t7}</header>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== details) {
    t9 = <GrantDetailsGrid details={details} />;
    $[17] = details;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== errorDetails) {
    t10 = errorDetails ? <GrantErrorDetails message={errorDetails} /> : null;
    $[19] = errorDetails;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
    t11 = <div className="tw-flex tw-flex-col tw-gap-4">{t8}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}